<template>
  <div>
    <language-tabs
      ref="languageTabs"
      v-model="form.translations"
      :errors="errors.translations"
      #default="{ translation, index, language, on, ...other }"
    >
      <url-form
        :value="translation"
        :language-id="language.id"
        :readonly="readonly"
        v-bind="other"
        v-on="on"
        @update-prop="updateValue($event, `translations.${index}`)"
        @valid="setValid(`translations.${index}`, $event)"
      />
    </language-tabs>
  </div>
</template>
<script>
import formEditable from '@/modules/_global/mixins/form-editable';
import LanguageTabs from '@/modules/_global/_components/LanguageTabs';
import multiValid from '@/modules/_global/mixins/multiple-valid';
import UrlForm from '@/modules/documents_links/components/forms/UrlForm';

export default {
  name: 'UrlLanguagesForm',
  components: {
    UrlForm,
    LanguageTabs
  },
  mixins: [formEditable, multiValid],
  data() {
    return {
      form: {
        translations: []
      }
    };
  },
  methods: {}
};
</script>
